export const updateAnswersAction = (item) => {
  return {
    type: 'UPDATE_JOURNEY_FEEDBACK_ANSWERS',
    item,
  };
};
